import {useListView} from '../core/ListViewProvider'
import {CmsServiceListToolbar} from './CmsServiceListToolbar'
import {CmsServiceListGrouping} from './CmsServiceListGrouping'
import {CmsServiceListSearchComponent} from './CmsServiceListSearchComponent'

const CmsServiceListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <CmsServiceListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <CmsServiceListGrouping /> : <CmsServiceListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {CmsServiceListHeader}
